export default "__VITE_ASSET__BngzDbsp__"